module.exports = __webpack_public_path__ + "static/media/galleryImg25.06552f6c.jpg";